module.exports = __webpack_public_path__ + "img/date-comes-back.f479f4aa.svg";